import { NgModule } from '@angular/core';

import { RefreshTokenService } from './services';

const PROVIDERS = [
  RefreshTokenService
];

@NgModule({
  providers: [
    ...PROVIDERS
  ]
})
export class UtilsRefreshTokenServiceModule {}
